import { tss } from 'tss-react';

// Material-UI component styles using sx prop
export const dialogSx = {
  '& .MuiDialog-paper': {
    position: 'fixed',
    top: '100px',
    margin: '0',
    maxHeight: 'calc(100vh - 200px)',
    borderRadius: '8px',
    overflow: 'visible'
  }
};

export const searchInputSx = {
  marginBottom: 1,
  '& .MuiInputBase-root': {
    fontSize: '16px',
    '& input': {
      padding: '8px'
    }
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '4px'
  },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderWidth: '1px'
  }
};

export const resultsListSx = {
  maxHeight: '350px',
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingTop: '4px',
  paddingBottom: '4px',
  // Apply Studio scrollbar styling
  '&::-webkit-scrollbar': {
    width: '8px',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderRadius: '100px'
  },
  '&::-webkit-scrollbar:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.09)'
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '100px'
  },
  '&::-webkit-scrollbar-thumb:active': {
    background: 'rgba(0, 0, 0, 0.61)',
    borderRadius: '100px'
  }
};

export const resultItemSx = (theme, isSelected, isDisabled) => ({
  padding: '2px 8px',
  borderRadius: '3px',
  cursor: isDisabled ? 'default' : 'pointer',
  marginBottom: '1px',
  transition: 'all 0.15s ease',
  minHeight: '28px',
  display: 'flex',
  alignItems: 'center',
  fontSize: '13px',
  opacity: isDisabled ? 0.5 : 1,
  '&:hover': {
    backgroundColor: !isDisabled ? theme.palette.action.hover : 'transparent'
  },
  ...(isSelected && {
    backgroundColor: theme.palette.primary.main + '1a', // 10% opacity
    color: theme.palette.primary.main,
    fontWeight: 500,
    '& .MuiListItemIcon-root': {
      color: theme.palette.primary.main
    }
  }),
  '& .MuiListItemText-secondary': {
    fontSize: '12px',
    color: theme.palette.text.secondary,
    opacity: 0.8,
    marginTop: '1px',
    lineHeight: '1.2'
  }
});

// HTML element styles using tss-react
export const getSearchModalClasses = tss.create({
  dialogContent: {
    padding: '12px',
    paddingBottom: '8px',
    overflow: 'hidden'
  },
  resultIcon: {
    minWidth: '24px',
    paddingLeft: '4px',
    marginRight: '8px',
    '& svg': {
      width: '16px',
      height: '16px',
      color: 'var(--text-secondary)'
    }
  },
  errorMessage: {
    color: 'red',
    fontSize: '14px',
    marginTop: '8px',
    marginBottom: '8px'
  },
  noResults: {
    padding: '16px',
    textAlign: 'center',
    color: '#666',
    fontSize: '14px'
  },
  primaryText: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  vklId: {
    fontSize: '11px',
    opacity: 0.75,
    fontFamily: 'monospace',
    backgroundColor: 'var(--background-secondary)',
    padding: '2px 5px',
    borderRadius: '3px',
    border: '1px solid var(--border-color)'
  }
});
